import { c as _c } from "react/compiler-runtime";
import { ExperienceInfo } from "../components/experiences/experience-id/ExperienceInfo";
import { jsx as _jsx } from "react/jsx-runtime";
export function ExperienceIdView(t0) {
  const $ = _c(2);
  const {
    experience
  } = t0;
  if (!experience) {
    return null;
  }
  let t1;
  if ($[0] !== experience) {
    t1 = /*#__PURE__*/_jsx("main", {
      className: "w-full",
      children: /*#__PURE__*/_jsx(ExperienceInfo, {
        experience: experience
      })
    });
    $[0] = experience;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}